angular.module('gym.calendar').directive('eventCancellationsDetails', function() {
  return {
    restrict: 'E',
    template: require('templates/gyms/calendar/events/event_cancellations_details.html.slim'),
    scope: {
      event: '=',
      variant: '@'
    },
    controller: ["$scope", "$rootScope", "EditEventService", function($scope, $rootScope, EditEventService) {
      $scope.currency = $rootScope.gym.currency_symbol;
      $scope.restrictCancellationsUnits = EditEventService.getRestrictCancellationsUnits();
      $scope.onRestrictCancellationsChange = function() {
        $scope.event.allow_late_cancellations = false;
        return $scope.onAllownLateCancellationsChange();
      };
      $scope.onAllownLateCancellationsChange = function() {
        if ($scope.event.allow_late_cancellations) {
          return $scope.event.late_cancellation_uses_up_class_allocation = true;
        } else {
          $scope.event.late_cancellation_fee = 0;
          return $scope.event.late_cancellation_uses_up_class_allocation = false;
        }
      };
      return $scope.tooltip = `<div class="long-content-tooltip-inner">
  Note: the late fee will be automatically added to the contact's next payment if there is a payment due within 2 weeks of the cancellation. If a scheduled payment does not exist, the fee will be scheduled for the day after the cancellation.
</div>`;
    }]
  };
});
